<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
                </Col>
                <Col span="8">
                    <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
                </Col>
                <Col span="8">
                  <div>
                    是否扣杂：
                    <template v-if="orderInfo.recoveryOrder.isDeduct == 0">否</template>
                    <template v-if="orderInfo.recoveryOrder.isDeduct == 1">是</template>
                  </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
                </Col>
                <Col span="8">
                    <div>订单总额：￥{{ orderInfo.recoveryOrder.totalAmount ? orderInfo.recoveryOrder.totalAmount : '-' }}
                    </div>
                </Col>
                <Col span="8">
                    <div>赠送积分：{{ orderInfo.recoveryOrder.integral ? orderInfo.recoveryOrder.integral : 0 }}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        订单类型：
                        <template v-if="orderInfo.recoveryOrder.orderType == 1">线上订单</template>
                        <template v-if="orderInfo.recoveryOrder.orderType == 2">线下订单</template>
                    </div>
                </Col>
                <Col span="8">
                    <div>支付类型：
                      <template v-if="orderInfo.recoveryOrder.payType == 1">线上支付</template>
                      <template v-if="orderInfo.recoveryOrder.payType == 2">线下支付</template>
                    </div>
                </Col>
              <Col span="8">
                <div>
                  订单状态：
                  <template v-if="orderInfo.recoveryOrder.orderState == 1">未接单</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 2">已接单</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 3">已完成</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 4">已取消</template>
                </div>
              </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        异常状态：
                        <template v-if="orderInfo.recoveryOrder.isAbnormal == 0">正常</template>
                        <template v-if="orderInfo.recoveryOrder.isAbnormal == 1">异常订单</template>
                    </div>
                </Col>
                <Col span="8">
                  <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
                </Col>
                <Col span="8">
                    <div>
                        异常原因：
                        <template v-if="orderInfo.recoveryOrder.abnormalCauses">{{
                                orderInfo.recoveryOrder.abnormalCauses
                            }}
                        </template>
                        <template v-else>-</template>
                    </div>
                </Col>
            </Row>

            <Divider orientation="left">回收类别信息</Divider>
            <Row v-for="(item,index) in orderInfo.recoveryOrderItem" :key="index">
                <Col span="9" style="margin-top: 10px">
                    <div class="j-order-image">
                        <div class="j-order-image-main">
                            <img :src="item.categoryImage">
                        </div>
                        <div class="j-order-image-info">
                          <div class="j-order-goods-title">
                              {{ item.categoryName }}
                              <template v-if="item.lowerCategoryName">
                                  - {{ item.lowerCategoryName }}
                              </template>
                          </div>
                          <div class="j-order-goods-price">
                            回收单价：
                            <InputNumber v-model="item.unitPrice" :min="0" :precision="2" :active-change="false" @on-blur="unitPriceVer(index)" style="width: 90px"/>元
                          </div>
                          <div class="j-order-goods-price">
                            回收重量：
                            <InputNumber v-model="item.weight" :min="0" :precision="1" :active-change="false" @on-blur="weightVer(item, index)" style="width: 90px"/>公斤
                          </div>
                          <div class="j-order-goods-price">
                            绩效比例：
                            <Select v-model="item.ratio" style="width:90px" @on-change="reduceRadioChange(index)">
                              <Option v-for="item in ratioList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                          </div>
                          <div class="j-order-goods-price">
                            绩效重量：{{ item.cutWeight }}公斤
                          </div>
                          <div class="j-order-goods-price">
                            回收总重量：{{ item.totalWeight }}公斤
                          </div>
                        </div>
                    </div>
                </Col>
                <Col span="15">
                      <div class="demo-upload-list"  v-for="(v,i) in formatImage(item.orderImage)">
                        <template>
                          <img :src="v">
                          <div class="demo-upload-list-cover">
                            <Icon type="ios-eye-outline" @click.native="previewImage(formatImage(item.orderImage))"></Icon>
                            <Icon type="ios-trash-outline" @click.native="handleRemove(item.orderImage, index)"></Icon>
                          </div>
                        </template>
                      </div>

                      <Upload
                          ref="upload"
                          :show-upload-list="false"
                          :on-success="(value)=> handleSuccess(index, value)"
                          :format="['jpg','jpeg','png']"
                          :max-size="6144"
                          :on-format-error="handleFormatError"
                          :on-exceeded-size="handleMaxSize"
                          :before-upload="handleBeforeUpload"
                          multiple
                          type="drag"
                          :action="action"
                          :headers="headers"
                          style="display: inline-block;width:58px;">
                        <div style="width: 58px;height:58px;line-height: 58px;">
                          <Icon type="ios-camera" size="20"></Icon>
                        </div>
                      </Upload>
<!--                    </div>-->
                </Col>
            </Row>

          <!-- 图片预览弹窗 -->
            <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
                <template scope="scope">
                    <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
                    {{ scope.options }}
                </template>
            </viewer>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="updateOrder()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
      <order-demo ref="orderDemo"></order-demo>
    </div>
</template>

<script>
import orderDemo from './order-info-map';
export default {
    data() {
        return {
          action: this.$uploadURL,
          headers: {
            token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
          },
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '修改订单',
            images: [],
            showImage: false,
            unitPrice: '',
          ratioList: [
            {
              value: 0,
              label: '0%'
            },
            {
              value: 0.05,
              label: '5%'
            },
            {
              value: 0.10,
              label: '10%'
            },
            {
              value: 0.15,
              label: '15%'
            },
          ],
          imgName: '',
          uploadList: []
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.isShowModal = true;
            this.getInfo(row);
            this.getTenantRatio();
        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
        getTenantRatio() {
          this.axios.post('/tenantConfig/findConfigByKey', {
            configKey: 'impairmentRatio'
          }).then(res => {
            if (res.status == 200) {
              let list = []
              let radio = res.data.split('|');
              radio.forEach(item => {
                let obj = {
                  value: item/100,
                  label: item + '%'
                }
                list.push(obj);
              })
              console.log(list);
              this.ratioList = list
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '查看减值比例接口报错',
                duration: 0
              });
            }
          })
        },
        inited(viewer) {
            this.$viewer = viewer
        },
        previewImage(images) {
            this.images = images;
            this.$viewer.show();
        },
        // 格式化图片
        formatImage(image) {
            if (image) {
                return image.split(',')
            }
        },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        unitPriceVer(index) {
          if (!this.orderInfo.recoveryOrderItem[index].unitPrice) {
            this.$Message.error('还有信息没有填写合格哦~');
            return
          }
          let totalAmount = 0;
          this.orderInfo.recoveryOrderItem.forEach(item => {
            let amount = item.unitPrice * item.weight
            amount = Math.floor(amount * 10) / 10
            totalAmount = totalAmount + amount
          })
          console.log('totalAmount', Math.floor(totalAmount * 10) / 10)
          this.orderInfo.recoveryOrder.totalAmount = Math.floor(totalAmount * 10) / 10
        },
        weightVer(item, index) {
          if (!this.orderInfo.recoveryOrderItem[index].weight) {
            this.$Message.error('还有信息没有填写合格哦~');
            return
          }
          let cutWeight = this.orderInfo.recoveryOrderItem[index].weight * this.orderInfo.recoveryOrderItem[index].ratio
          console.log('cutWeight', Math.floor(cutWeight * 10) / 10);
          let totalWeight = parseFloat(this.orderInfo.recoveryOrderItem[index].weight) + cutWeight
          console.log('totalWeight--', Math.floor(totalWeight * 10) / 10);
          this.orderInfo.recoveryOrderItem[index].cutWeight = Math.floor(cutWeight * 10) / 10
          this.orderInfo.recoveryOrderItem[index].totalWeight = Math.floor(totalWeight * 10) / 10
          this.unitPriceVer(index);
        },
        reduceRadioChange(index) {
          let cutWeight = this.orderInfo.recoveryOrderItem[index].weight * this.orderInfo.recoveryOrderItem[index].ratio
          let totalWeight = parseFloat(this.orderInfo.recoveryOrderItem[index].weight) + cutWeight
          this.orderInfo.recoveryOrderItem[index].totalWeight = Math.floor(totalWeight * 10) / 10// 保留一位小数，并舍去剩余小数位
          this.orderInfo.recoveryOrderItem[index].cutWeight = Math.floor(cutWeight * 10) / 10
        },
        showOrderDemo() {
          this.$refs.orderDemo.show(this.orderInfo);
        },

      updateOrder() {
        this.orderInfo.recoveryOrderId = this.orderInfo.recoveryOrder.recoveryOrderId

        let flag = false
        this.orderInfo.recoveryOrderItem.forEach(item => {
          if (!item.unitPrice || !item.weight || !item.orderImage || item.orderImage === '') {
            flag = true
          }
        })
        if (flag) {
          this.$Message.error('还有信息没有填写合格哦~');
          return
        }
        this.axios.post('/recoveryOrder/updateOrder', this.orderInfo).then(res => {
          if (res.status == 200) {
            this.$emit('changeDate');
            this.$Message.success('操作成功.');
            this.hide('formValidate');
          }
          if(res.status == 201){
            this.$Message.error(res.msg);
          }
          if (res.status == 500) {
            this.$Notice.error({
              title: '服务器内部错误',
              desc: '修改订单接口报错',
              duration: 0
            });
          }
        })
      },
      // 从 upload 实例删除数据
      handleRemove (imgUrl, index) {
        // 转为数组
        let imgArr = this.orderInfo.recoveryOrderItem[index].orderImage.split(",");
        // 删除url
        imgArr.splice(imgArr.indexOf(imgUrl), 1)
        // 数组再次转为字符串
        this.orderInfo.recoveryOrderItem[index].orderImage = imgArr.join(",");
      },
      handleSuccess (index, value) {
        if (this.orderInfo.recoveryOrderItem[index].orderImage !== '') {
          // 转为数组
          let imgArr = this.orderInfo.recoveryOrderItem[index].orderImage.split(",");
          // 插入url
          imgArr.push(value.data)
          // 数组再次转为字符串
          this.orderInfo.recoveryOrderItem[index].orderImage = imgArr.join(",");
        } else {
          this.orderInfo.recoveryOrderItem[index].orderImage = value.data
        }
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: '文件格式不正确',
          desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
        });
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '超出文件大小限制',
          desc: '文件 ' + file.name + ' 太大，不能超过 6M。'
        });
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 8;
        if (!check) {
          this.$Notice.warning({
            title: '最多只能上传 8 张图片。'
          });
        }
        return check;
      }
    },
    components: {
      orderDemo
    }
}
</script>

<style scoped lang="less">
/deep/ .ivu-input-number-handler-wrap {
  visibility:hidden
}
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-title {
          font-weight: bold;
        }

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}

.demo-upload-list{
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  margin-right: 4px;
}
.demo-upload-list img{
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover{
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.6);
}
.demo-upload-list:hover .demo-upload-list-cover{
  display: block;
}
.demo-upload-list-cover i{
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

</style>